module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.headerComponentName) ? _c(_vm.headerComponentName, {
    tag: "component",
    attrs: {
      "id": "header"
    },
    on: {
      "logout": _vm.logout
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4f590b45!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/global/GuestHeader.vue
// module id = 703
// module chunks = 0